(ns frontend.view.nev.kyc.process-status-views.template-status
  (:require
   [common.localization :as loc]
   [common.schema.entities.workspace.kyc.questions.prefill-data :as prefill-data]
   [common.schema.entities.workspace.kyc.templates.template-registry :as template-registry]
   [common.schema.registry :as registry]
   [frontend.actions.entity :as entity-actions]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.view.entity-viewers.components :as fe]
   [frontend.view.nev.kyc.process-status-views.view-utils :as kvu]
   [ui.components.button.view :as button]
   [ui.dom-globals :as dg]))

(defn prefill-answers
  [state-atom template-kw process-id profile]
  (let [target-id (:kyc-profile/target profile)
        investor (session/get-entity target-id)
        legal-entity (session/get-entity (:investor/legal-entity investor))
        template-schema (template-registry/templates template-kw)
        previous-process (some->> profile
                                  :kyc-profile/kyc-processes
                                  (map session/get-entity)
                                  (filter
                                   (fn [kyc-process]
                                     (and (not= (:db/id kyc-process) process-id)
                                          (= (:kyc-process/template kyc-process) template-kw))))
                                  (sort-by :common/created-on)
                                  (last))
        default-data (prefill-data/default-data template-schema legal-entity)
        template-question-kws (->> template-schema
                                   vals
                                   (mapcat :questions)
                                   keys
                                   (remove nil?))
        do-not-copy-kws (->> template-schema
                             (vals)
                             (mapcat :questions)
                             (filter (fn [[_q meta]]
                                       (:skip-previous-answers-copy? meta)))
                             (keys)
                             (remove nil?))
        previous-answers (-> previous-process
                             :kyc-process/answers
                             (select-keys template-question-kws))

        previous-answers (apply dissoc previous-answers do-not-copy-kws)

        current-answers (-> @state-atom
                            :kyc-process/answers
                            (select-keys template-question-kws))
        combined-answers (merge default-data
                                (when (map? previous-answers)
                                  previous-answers)
                                current-answers)]
    (swap! state-atom assoc :kyc-process/answers combined-answers)
    (deref state-atom)))

(defn view
  [state-atom entity save!]
  (let [entity-template (registry/get-schema @session/tenant-schema :entity.type/kyc-process)
        kyc-template (some->> @state-atom
                              :kyc-process/template
                              (get template-registry/templates))
        available-languages-set (set (or (:kyc-template/available-languages kyc-template)
                                         [:ENG :FIN]))
        available-language-options (->> entity-template
                                        :kyc-process/language
                                        :options
                                        (filterv (fn [opt]
                                                   (contains? available-languages-set (:key opt)))))
        entity-template (assoc-in entity-template [:kyc-process/language :options] available-language-options)
        entity-template-lookup (->> entity-template
                                    (vals)
                                    (map (fn [field-schema]
                                           [(:attribute field-schema) field-schema]))
                                    (into {}))
        valid-language-selected? (and (:kyc-process/language entity)
                                      (->> entity
                                           :kyc-process/language
                                           (contains? available-languages-set)))]

    [:div.d-flex.flex-column.flex-1-hidden
     [:div.d-flex.flex-column.flex-1-hidden.scroll-y-container
      [:div.container.pt-4
       [:div.card--kyc.card--kyc--min-height
        [:div.card-body
         [:div.select-area
          [fe/field-editor
           {:attribute              :kyc-process/template
            :tenant                 nil
            :draggable?             false
            :entity                 entity
            :state-atom             state-atom
            :tools                  [:tool-item/cancel :tool-item/save :tool-item/edit :tool-item/clear]
            :entity-template-lookup entity-template-lookup}]]
         [:div.select-area
          [fe/field-editor
           {:attribute              :kyc-process/language
            :tenant                 nil
            :draggable?             false
            :entity                 entity
            :state-atom             state-atom
            :tools                  [:tool-item/cancel :tool-item/save :tool-item/edit :tool-item/clear]
            :entity-template-lookup entity-template-lookup}]]]]]]

     [:div.d-flex.flex-static.kyc-submit-footer
      [:div.container
       [:div.d-flex.justify-content-between
        [kvu/exit-button entity :en]
        [:div
         {:class "flex gap-3"}
         [button/danger-solid
          {:on-click (fn [_]
                       (entity-actions/*->disable! (:db/id entity)
                                                   (fn [_resp]
                                                     (dg/history-back))
                                                   (fn [resp]
                                                     (logging/error "Failed to complete KYC "
                                                                    resp))))}
          (loc/tr :delete-draft)]

         [button/primary-solid
          {:disabled? (not (and valid-language-selected?
                                (:kyc-process/template entity)))
           :on-click  (fn [_]
                        (entity-actions/*->field-update!
                         (:db/id entity)
                         :kyc-process/status
                         :kyc-process.status/draft
                         (fn [_success]
                           (let [profile (->> @session/all-kyc-profiles
                                              (filter (fn [p]
                                                        (some #{(:db/id entity)}
                                                              (:kyc-profile/kyc-processes p))))
                                              (first))]
                             (prefill-answers state-atom
                                              (:kyc-process/template @state-atom)
                                              (:db/id entity)
                                              profile)
                             (save!)))
                         (fn [error]
                           (logging/error "Failed to save answers : " error))))}
          (loc/tr :continue)]]]]]]))

